/**
 * CancelScheduledModal — E-93 Story 93.6.
 *
 * Confirmation dialog before cancelling an ütemezett batch. NO type-to-
 * confirm gate (cancel is destructive but reversible only by re-sending
 * — much lower blast radius than a 100+ accidental send) — a simple
 * "are you sure" suffices. Snapshot props mirror ConfirmSendModal
 * so the parent state is the source of truth.
 */

import { useTranslation } from '@kgc/i18n';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@kgc/ui';
import type { JSX } from 'react';

export interface CancelScheduledModalProps {
  open: boolean;
  onOpenChange: (next: boolean) => void;
  recipientCount: number;
  templateSlug: string;
  onConfirm: () => void;
}

export function CancelScheduledModal({
  open,
  onOpenChange,
  recipientCount,
  templateSlug,
  onConfirm,
}: CancelScheduledModalProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('email.scheduled.cancelModal.title')}</DialogTitle>
          <DialogDescription>
            {t('email.scheduled.cancelModal.description', {
              count: recipientCount,
              templateSlug,
            })}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('email.scheduled.cancelModal.dismissButton')}
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            {t('email.scheduled.cancelModal.confirmButton')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
